<template>
  <div id="knowledgeContent">
    <div class="searchBox">
      <el-input style="max-width: 400px" v-model="searchKnowledge"></el-input>
      <el-button icon="el-icon-search" @click="knowledgeToSearch()"></el-button>
    </div>
    <div id="knowledgeGraphContent"></div>
    <div class="knowledgeListBox">
      <div class="closeList" @click="closeList()">
        <i class="el-icon-close"></i>
      </div>
      <div class="clickTitle"><a href="javascript:;"></a></div>
      <ul class="clickContent">
        <li><a href="javascript:;">111</a></li>
        <li><a href="javascript:;">222</a></li>
        <li><a href="javascript:;">333</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import cookies from "vue-cookies";
import * as echarts from "echarts";
export default {
  data() {
    return { searchKnowledge: "" };
  },
  mounted() {
    var that = this;
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
    });
    var tagSearch = window.location.search;
    // console.log(decodeURI(tagSearch.split("=")[1]));
    var knowledgeGraphChart = echarts.init(
      document.querySelector("#knowledgeGraphContent")
    );
    this.searchParam(decodeURI(tagSearch.split("=")[1]));
    knowledgeGraphChart.on("click", function (params) {
      $(".knowledgeListBox ").show();
      $(".clickTitle a").text(params.data.name);
      that.searchParam(params.data.name);
    });
  },
  methods: {
    searchParam(contentText) {
      var that = this;
      //   var tagSearch = window.location.search;
      var knowledgeGraphChart = echarts.init(
        document.querySelector("#knowledgeGraphContent")
      );
      // 知识图谱
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/word/knowledgeGraph",
        data: { wordName: contentText },
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            var knowledgeData = [];
            for (var i = 0; i < response.obj.nodes.length; i++) {
              var symbolData = "";
              if (response.obj.nodes[i].url == "") {
                symbolData = "image://" + require("../../../img/knowledge.png");
                knowledgeData.push({
                  id: response.obj.nodes[i].id,
                  name: response.obj.nodes[i].name,
                  symbol: symbolData,
                });
              } else {
                // var currentNodePic = that.getImgData(response.obj.nodes[i].url);
                // console.log(currentNodePic);
                // var nodePic = [];
                // nodePic.push(currentNodePic);
                knowledgeData.push({
                  id: response.obj.nodes[i].id,
                  name: response.obj.nodes[i].name,
                  symbol: "",
                });
                let j = i;
                var nodeData = [];
                var p = that.getImgData(response.obj.nodes[i].url);
                nodeData.push(p);
                Promise.all(nodeData).then(
                  function (images) {
                    for (var k = 0; k < images.length; k++) {
                      //   console.log("image://zyk" + images[k]);
                      // console.log(knowledgeData[c].symbol);
                      knowledgeData[j].symbol = "image://zyk" + images[k];
                    }
                  }
                  //   (values) => {
                  //     symbolData = "image://zyk" + values;
                  //     // console.log(symbolData);
                  //   }
                );
                Promise.race(nodeData).then(
                  function (images) {
                    for (var k = 0; k < images.length; k++) {
                      //   console.log("image://zyk" + images[k]);
                      // console.log(knowledgeData[c].symbol);
                      knowledgeData[j].symbol = "image://zyk" + images[k];
                    }
                  }
                  //   (values) => {
                  //     symbolData = "image://zyk" + values;
                  //     // console.log(symbolData);
                  //   }
                );
                // console.log(symbolData);
                // symbolData = "image://zyk" + response.obj.nodes[i].url;
              }
              //   knowledgeData.push({
              //     id: response.obj.nodes[i].id,
              //     name: response.obj.nodes[i].name,
              //     symbol: symbolData,
              //   });
            }
            // console.log(knowledgeData);
            if (response.obj.nodes.length == 0) {
              that.$message({
                message: "暂无相关知识点",
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
              });
              that.searchKnowledge = "";
            } else {
              var knowledgeGraphoption = {
                tooltip: {},
                series: [
                  {
                    name: "知识图谱",
                    type: "graph",
                    layout: "force",
                    symbolSize: 22,
                    symbol: "circle",
                    legendHoverLink: true,
                    data: knowledgeData,
                    links: response.obj.links,
                    roam: true, //缩放和平移
                    draggable: true, //节点可拖拽
                    zoom: 4,
                    center: ["50%", "50%"],
                    label: {
                      show: true,
                      position: "bottom",
                      color: "#fbfbe3",
                    },
                    itemStyle: {
                      color: "#fbfbe3",
                    },
                    force: {
                      repulsion: 90,
                      layoutAnimation: false,
                    },
                  },
                ],
              };
              knowledgeGraphChart.setOption(knowledgeGraphoption);
            }
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    knowledgeToSearch() {
      var that = this;
      that.searchParam(that.searchKnowledge);
    },
    closeList() {
      $(".knowledgeListBox ").hide();
    },
    // 获取icon的图片信息
    getImgData(imgSrc) {
      var fun = function (resolve) {
        const canvas = document.createElement("canvas");
        const contex = canvas.getContext("2d");
        const img = new Image();
        img.crossOrigin = "";

        img.onload = function () {
          // 设置图形宽高比例
          var center = {
            x: img.width / 2,
            y: img.height / 2,
          };
          var diameter = img.width;
          var radius = diameter / 2; // 半径

          canvas.width = diameter;
          canvas.height = diameter;
          contex.clearRect(0, 0, diameter, diameter);
          contex.save();
          contex.beginPath();
          contex.arc(radius, radius, radius, 0, 2 * Math.PI); // 画出圆
          contex.clip();
          contex.drawImage(
            img,
            center.x - radius,
            center.y - radius,
            diameter,
            diameter,
            0,
            0,
            diameter,
            diameter
          ); // 在刚刚裁剪的园上画图
          contex.restore(); // 还原状态
          resolve(canvas.toDataURL("image/png", 1));
        };
        img.src = imgSrc;
      };
      //   var promise = new Promise((resolve) => {
      //     resolve(fun);
      //   });
      var promise = new Promise(fun);
      console.log(promise);
      return promise;
    },
  },
};
</script>

<style>
#knowledgeContent {
  background-image: url(../../../img/knowledgeBG.jpg);
  height: 100vh;
  overflow: hidden;
  position: relative;
}

#knowledgeContent .searchBox {
  width: 400px;
  position: absolute;
  top: 3%;
  left: 1%;
  z-index: 15;
}
#knowledgeContent .searchBox .el-button {
  position: absolute;
  border: none;
  font-size: 30px;

  padding: 0;
  bottom: 3px;
  right: 10px;
}

#knowledgeGraphContent {
  height: 100vh;
}

.knowledgeListBox {
  display: none;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 500px;
  height: 500px;
  background-color: #fbfbe3;
  border-left: 5px solid #f9c5b7;
  border-top: 5px solid #f9c5b7;
  border-radius: 500px 0 0 0;
  z-index: 15;
}

.knowledgeListBox .closeList {
  float: right;
  font-size: 30px;
  font-weight: bolder;
  cursor: pointer;
  z-index: 20;
}

.knowledgeListBox .clickTitle {
  text-align: right;
  color: #0d2115;
  width: 100%;
  margin-top: 60px;
  font-size: 24px;
  font-weight: bolder;
  letter-spacing: 0.05em;
}

.knowledgeListBox .clickTitle a {
  max-width: 240px;
  padding-right: 15px;
}

.knowledgeListBox .clickContent {
  position: absolute;
  padding: 10px 10px;
  bottom: 0;
  right: 0;
  text-align: left;
  border: 1px solid #000;
  width: 345px;
  height: 345px;
  overflow-y: scroll;
}
.knowledgeListBox .clickContent li {
  list-style-type: disc;
  list-style-position: inside;
  color: #0d2115;
}

.knowledgeListBox .clickContent li a {
  color: #0d2115;
}
</style>